import { useSearchParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import useOrdersByState from "../components/orders/useOrdersByState";
import useTransitionModal from "../components/orders/useTransitionModal";
import useBillingModal from "../components/orders/useBillingModal";
import OrdersTable from "../components/orders/OrdersTable";
import TransitionModal from "../components/orders/TransitionModal";
import BillingModal from "../components/orders/BillingModal";

export default function AdminOrdersByState() {
  const [params] = useSearchParams();
  const state = params.get("state") || "AP";
  const list = useOrdersByState(state);
  const tx = useTransitionModal({ onCommitted: list.load });
  const billing = useBillingModal();

  return (
    <div data-testid="admin-orders-treat">
      <Link to="/admin" data-testid="back-to-dashboard"
        className="inline-flex items-center gap-1 text-xs text-[#978D78] hover:text-[#0F1829] mb-3">
        <ArrowLeft size={13} /> Voltar ao dashboard
      </Link>
      <div className="mb-5">
        <h1 className="text-2xl font-bold" style={{ fontFamily: "'Fraunces', serif" }}>
          Encomendas em «{list.currentStateLabel}»
        </h1>
        <p className="text-xs font-mono text-[#978D78]">Estado: {state}</p>
      </div>
      <OrdersTable
        rows={list.rows} loading={list.loading} error={list.error}
        total={list.total} page={list.page} setPage={list.setPage} totalPages={list.totalPages}
        pageSize={list.pageSize} setPageSize={list.setPageSize}
        search={list.search} setSearch={list.setSearch}
        onTransition={tx.open} onBilling={billing.open}
      />
      <TransitionModal
        order={tx.order} availableStates={list.availableStates}
        notes={tx.notes} setNotes={tx.setNotes}
        sendEmail={tx.sendEmail} setSendEmail={tx.setSendEmail}
        rastreamento={tx.rastreamento} setRastreamento={tx.setRastreamento}
        sending={tx.sending} onClose={tx.close} onTransition={tx.transition} onSendMessage={tx.sendMessage}
      />
      <BillingModal
        order={billing.order} data={billing.data} loading={billing.loading}
        emitting={billing.emitting} message={billing.message}
        onClose={billing.close} onEmit={billing.emitDoc} onRecalc={billing.recalcCommissions}
        onResendPrEmail={billing.resendPrEmail}
        onRefreshCofidis={billing.refreshCofidisLink}
      />
    </div>
  );
}
